import React from "react";
import { ArrowRightIcon } from "lucide-react";
import { CHECKOUT_URL } from "../data/offer";
type CtaButtonProps = {
  label: string;
  id?: string;
  className?: string;
};
export function CtaButton({
  label,
  id,
  className = ""
}: CtaButtonProps) {
  return <a id={id} href={CHECKOUT_URL} className={`group inline-flex min-h-[64px] w-full items-center justify-center gap-3 rounded-2xl bg-brand px-5 py-4 text-center text-[15px] font-extrabold uppercase tracking-wide text-white shadow-cta transition-[transform,background-color] duration-150 ease-out hover:bg-brand-hover active:scale-[0.97] focus:outline-none focus-visible:ring-4 focus-visible:ring-brand/40 sm:w-auto sm:px-10 sm:text-lg ${className}`} data-id="element-30" data-mp="hhj26x77xry1">
      <span className="leading-snug" data-id="element-31" data-mp="vc28vku73hm5">{label}</span>
      <ArrowRightIcon className="h-5 w-5 shrink-0 transition-transform duration-150 ease-out group-hover:translate-x-1" aria-hidden="true" data-id="element-32" data-mp="19ajrj458u3x7" />
    </a>;
}